import { Table } from '~/components/common';

import { useClaimStore } from '~/store';
import { getClaimReturnRegisterReturnItemsColumnDefs } from '~/utils';

import type { TypeReturnRegisterSecondStepValues, TypeReturnRegisterSecondStepValuesState } from '~/types/claim.types';

import styles from '../ClaimReturnRegisterSecondStepContent.module.scss';

const ClaimReturnRegisterSecondStepReturnGoodsTable = ({
  data,
  dataState,
  onChange,
  onChangeState,
}: {
  data: TypeReturnRegisterSecondStepValues['returnOrderItems'];
  dataState: TypeReturnRegisterSecondStepValuesState['returnOrderItems'];
  onChange: (values: Partial<TypeReturnRegisterSecondStepValues>) => void;
  onChangeState: (values: Partial<TypeReturnRegisterSecondStepValuesState>) => void;
}) => {
  const selectOptions = useClaimStore((state) => state.selectOptions.returnReason);

  const { columnDefs, gridOptions } = getClaimReturnRegisterReturnItemsColumnDefs({
    data,
    dataState,
    selectOptions,
    onChange,
    onChangeState,
  });

  return (
    <div className={styles['table-wrapper']}>
      <Table data={data} options={{ columnDefs, ...gridOptions }} />
    </div>
  );
};

export default ClaimReturnRegisterSecondStepReturnGoodsTable;
